export const environment = {
  production: true,
  BASE_URL: "https://backend.goldentaxi.com.br/api/v1/golden-taxi",
  WS_URL: "https://backend.goldentaxi.com.br"
};
